import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_heartFull",
  "use": "icon_heartFull-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 48 48\" id=\"icon_heartFull\"><path fill=\"currentColor\" d=\"M24 41C7.443 28.166 5 24.577 5 17.298 5 11.611 9.701 7 15.5 7c3.495 0 6.591 1.675 8.5 4.251A10.551 10.551 0 0132.5 7C38.299 7 43 11.61 43 17.298c0 7.28-2.443 10.868-19 23.702z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol